import { render, staticRenderFns } from "./Tokushoho.vue?vue&type=template&id=3f8545fb&scoped=true&lang=pug"
import script from "./Tokushoho.vue?vue&type=script&lang=js"
export * from "./Tokushoho.vue?vue&type=script&lang=js"
import style0 from "./Tokushoho.vue?vue&type=style&index=0&id=3f8545fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8545fb",
  null
  
)

export default component.exports